
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Lock, Settings2 } from "lucide-react";

export const SecuritySettings = () => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Security Settings</h3>
      <div className="space-y-4">
        <Button variant="outline" className="w-full justify-start">
          <Lock className="w-4 h-4 mr-2" />
          Change Password
        </Button>
        <Button variant="outline" className="w-full justify-start">
          <Settings2 className="w-4 h-4 mr-2" />
          Two-Factor Authentication
        </Button>
      </div>
    </Card>
  );
};
